"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigUtils = exports.ParseBigError = exports.Utils = exports.logError = void 0;
const moment_1 = __importDefault(require("moment"));
const big_js_1 = require("big.js");
const ferrum_plumbing_1 = require("ferrum-plumbing");
function logError(msg, err) {
    console.error(msg, err);
    // Sentry.captureException(err);
}
exports.logError = logError;
function href() {
    // @ts-ignore
    return window.location.href;
}
class Utils {
    static getQueryparams() {
        const rv = {};
        const queryParams = (href().split('?')[1] || '').split('&').map(p => p.split('='));
        queryParams.forEach(p => rv[p[0]] = p[1]);
        return rv;
    }
    static getQueryparam(param) {
        return Utils._getQueryparam(href(), param);
    }
    static _getQueryparam(href, param) {
        const queryParams = (href.split('?')[1] || '').split('&').map(p => p.split('='));
        return (queryParams.find(p => p[0] === param) || [])[1];
    }
    static getRoute(subRoute) {
        let base = href().split('?')[0];
        if (!base.endsWith('/')) {
            base = base + '/';
        }
        return base + subRoute;
    }
    static ellipsis(s, len) {
        if (s.length <= len) {
            return s;
        }
        return `${s.substr(0, len - 3)}...`;
    }
    static strLength(s) {
        return s.length;
    }
    static shorten(s) {
        if (s.length <= 25) {
            return s;
        }
        return `${s.substr(0, 10)}...${s.substr(s.length - 10)}`;
    }
    static linkForAddress(network, addr) {
        switch (network.toLocaleLowerCase()) {
            case 'rinkeby':
                return `https://rinkeby.etherscan.io/address/${addr}`;
            case 'ethereum':
                return `https://etherscan.io/address/${addr}`;
            case 'bsc':
                return `https://bscscan.com/address/${addr}`;
            case 'bsc_testnet':
                return `https://testnet.bscscan.com/address/${addr}`;
            case 'mumbai_testnet':
                return `https://mumbai.polygonscan.com/address/${addr}`;
            case 'polygon':
                return `https://polygonscan.com/address/${addr}`;
        }
        return '';
    }
    static linkForTransaction(network, tid) {
        switch (network.toLocaleLowerCase()) {
            case 'rinkeby':
                return `https://rinkeby.etherscan.io/tx/${tid}`;
            case 'ethereum':
                return `https://etherscan.io/tx/${tid}`;
            case 'bsc':
                return `https://bscscan.com/tx/${tid}`;
            case 'bsc_testnet':
                return `https://testnet.bscscan.com/tx/${tid}`;
            case 'mumbai_testnet':
                return `https://mumbai.polygonscan.com/tx/${tid}`;
            case 'polygon':
                return `https://polygonscan.com/tx/${tid}`;
        }
        return '';
    }
    static tillDate(date) {
        var endDate = new Date(date * 1000);
        var now = new Date();
        var m = moment_1.default(endDate);
        const d2 = moment_1.default(now);
        var years = m.diff(d2, 'years');
        m.add(-years, 'years');
        var months = m.diff(d2, 'months');
        m.add(-months, 'months');
        var days = m.diff(d2, 'days');
        m.add(-days, 'days');
        var hours = m.diff(d2, 'hours');
        m.add(-hours, 'hours');
        var minutes = m.diff(d2, 'minutes');
        m.add(-minutes, 'minutes');
        return [years * 12 + months,
            days, hours, minutes];
    }
    static union(a1, a2, keyFun) {
        const rv = new Map();
        a1.forEach(a => { rv.set(keyFun(a), a); });
        a2.forEach(a => { rv.set(keyFun(a), a); });
        return Array.from(rv.keys()).map(k => rv.get(k));
    }
    static parseCurrency(cur) {
        const pars = cur.split(':', 2);
        return [pars[0], pars[1]];
    }
    static toCurrency(network, address) {
        if (!network || !address)
            return undefined;
        return `${network.toUpperCase()}:${address.toLowerCase()}`;
    }
    static isCurrencyValid(cur) {
        if (!cur) {
            return false;
        }
        const [network, token] = Utils.parseCurrency(cur);
        if (!token) {
            return false;
        }
        if (!network) {
            return false;
        }
        if (!token.startsWith('0x')) {
            return false;
        }
        if (token.length != 42) {
            return false;
        }
        if (!ferrum_plumbing_1.Networks.CHAINS_BY_ID.get(network)) {
            return false;
        }
        return true;
    }
    static isNonzeroAddress(address) {
        if (!address) {
            return false;
        }
        const zero = address.replace('0x', '').replace(/0/g, '').length == 0;
        return !zero;
    }
    static addressEqual(a1, a2) {
        if (!a1 || !a2)
            return false;
        return a1.toLowerCase() === a2.toLowerCase();
    }
}
exports.Utils = Utils;
class ParseBigError extends Error {
}
exports.ParseBigError = ParseBigError;
class BigUtils {
    static truthy(b) {
        return !!b && !(new big_js_1.Big(0).eq(b));
    }
    static safeParse(s) {
        try {
            return new big_js_1.Big(s);
        }
        catch (e) {
            return new big_js_1.Big('0');
        }
    }
    static parseOrThrow(s, varName) {
        try {
            return new big_js_1.Big(s);
        }
        catch (e) {
            throw new ParseBigError(`Error parsing ${varName}. "${s}" is not a valid number`);
        }
    }
}
exports.BigUtils = BigUtils;
//# sourceMappingURL=Utils.js.map